// Options for renderer dropdown (matches Figma design)
export const teamInvolvementRendererOptions = [
  {
    label: 'Yes',
    value: 'influenced',
    description: 'My team did help with this hire.',
    descriptionBold: 'did',
    badgeLabel: 'Team assisted',
    badgeBg: 'green.20', // #F4FBF6
    badgeColor: 'green.700', // #157533
  },
  {
    label: 'No',
    value: 'no_influence',
    description: 'My team did not help with this hire.',
    descriptionBold: 'did not',
    badgeLabel: 'No',
    badgeBg: 'neutral.50', // #EDF2F7
    badgeColor: 'neutral.500', // #67738B
  },
  {
    label: 'Unknown',
    value: 'unknown',
    description: "I'm not sure if my team helped with this hire.",
    descriptionBold: "I'm not sure",
    badgeLabel: 'Unknown',
    badgeBg: 'neutral.50', // #EDF2F7
    badgeColor: 'neutral.500', // #67738B
  },
];

// Options for filter dropdown
export const teamInvolvementOptions = [
  { label: 'Team assisted', value: 'influenced' },
  { label: 'Not team assisted', value: 'no_influence' },
  { label: 'Unknown', value: 'unknown' },
  { label: 'Not reviewed', value: 'pending_review' },
];
